import { Button, Divider, Flex, Grid, LoadingOverlay, Text } from "@mantine/core";
import React from "react";
import { useNavigate } from "react-router";
import * as yup from "yup";
import { AuthApi, LbfParticipantApi, LbfProgramApi } from "../../apis";
import { tugrug } from "../../utils";
import HttpHandler from "../../utils/http-handler";
import { Message } from "../../utils/message";
import { Form } from "../form";
import { OtpField } from "../form/otp-field";
import { TextareaField } from "../form/textarea-field";

const schema = yup.object({
  pin: yup.string().min(6, "Заавал бөглөнө!").required("Заавал бөглөнө!").nullable(),
});

type IFormData = {
  pin: string;
  reviewDesc: string;
  review: boolean;
  type: boolean;
};

export function FundingProgramBuyerLedReviewForm({ data, onCancel, success, type }: { data: any; onCancel: () => void; success: any; type: string }) {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState<boolean>(false);
  const [status, setStatus] = React.useState<boolean>(false);
  const [initialData] = React.useState<IFormData>({
    pin: "",
    reviewDesc: "",
    review: false,
    type: false,
    ...(type === "BUYER_LED" || type === "SUPPLIER_LED" ? { type: true } : {}),
  });

  const onSubmit = async (value: IFormData) => {
    setLoading(true);
    try {
      await AuthApi.checkPin({ pin: value?.pin });

      switch (type) {
        case "BUYER_LED": {
          await LbfProgramApi.review(data?.id, {
            review: status,
            reviewDesc: value?.reviewDesc,
          });
          Message.success("Амжилттай хөтөлбөрийн үндсэн мэдээллийг хянасан.");
          navigate("/cf/funding-program/BUYER");
          break;
        }
        case "SUPPLIER_LED": {
          await LbfProgramApi.review(data?.id, {
            review: status,
            reviewDesc: value?.reviewDesc,
          });
          Message.success("Амжилттай хөтөлбөрийн үндсэн мэдээллийг хянасан.");
          navigate("/cf/funding-program/SUPPLIER");
          break;
        }
        case "PARTICIPANT-REVIEW": {
          await LbfParticipantApi.review({ lbfProgramId: data.lbfProgramId, smeBusinessId: data.smeBusinessId });
          Message.success("Амжилттай хянаж зөвшөөрсөн.");
          break;
        }
        case "PARTICIPANT-TO_REVIEW": {
          await LbfParticipantApi.toReview({ lbfProgramId: data.lbfProgramId, smeBusinessId: data.smeBusinessId });
          Message.success("Амжилттай хяналтад илгээлээ.");
          break;
        }
      }
      onCancel();
      success();
    } catch (err) {
      Message.error((err as HttpHandler)?.message!);
    }
    setLoading(false);
  };

  return (
    <Form validationSchema={schema} onSubmit={onSubmit} initialValues={initialData}>
      {({ values }) => {
        return (
          <>
            <LoadingOverlay visible={loading} />
            <Divider />
            <Grid grow gutter={1}>
              <Grid.Col span={12} mt={10}>
                {type === "BUYER_LED" && (
                  <Text size="sm" weight={500} c="#44566C" style={{ letterSpacing: 1 }}>
                    Та {data?.refCode || "-"} дугаартай хөтөлбөрийг хянасан төлөвт оруулж байна. ПИН кодоор баталгаажуулна уу. Хөтөлбөрийн нийлүүлэгчийн лимит
                    хянасны дараа хөтөлбөрийг идэвхжүүлэх боломжтойг анхаарна уу.
                  </Text>
                )}
                {type === "PARTICIPANT-REVIEW" && (
                  <Text size="sm" weight={500} c="#44566C" style={{ letterSpacing: 1 }}>
                    Та нийлүүлэгчийн лимит хянасан төлөвт оруулж байна. Пин кодоор баталгаажуулна уу.
                  </Text>
                )}
                {type === "PARTICIPANT-TO_REVIEW" && (
                  <Text size="sm" weight={500} c="#44566C" style={{ letterSpacing: 1 }}>
                    Та {data?.programName || "-"} хөтөлбөрт {data?.clientCode || "-"} CIF дугаартай `{data?.profileName || "-"}`-т {tugrug(data?.subLimit || 0)}{" "}
                    төгрөгийн лимит бүртгэлээ. Хяналтад илгээх бол ПИН кодоор баталгаажуулна уу.
                  </Text>
                )}
              </Grid.Col>
              <Grid.Col span={12} mt={10}>
                <OtpField name="pin" label="Пин код." placeholder="" required />
              </Grid.Col>
              {values.type && (
                <Grid.Col span={12} mb={10}>
                  <TextareaField name="reviewDesc" label="Тайлбар:" placeholder="Тайлбар энд бичих" maxLength={255} withAsterisk={false} />
                </Grid.Col>
              )}
            </Grid>
            <Flex justify="flex-start" align="center" direction="column" wrap="wrap" mb={10}>
              <Text size="sm" weight={500} c="#141517">
                Танд амжилт хүсье.
              </Text>
            </Flex>
            <Divider />
            <Flex mt={20} direction="row" justify="space-between">
              {type === "BUYER_LED" ? (
                <>
                  <Button variant="outline" onClick={() => setStatus(false)} color="red" type="submit">
                    Татгалзах
                  </Button>
                  <Button variant="outline" onClick={() => setStatus(true)} color="green" type="submit">
                    Баталгаажуулах
                  </Button>
                </>
              ) : (
                <>
                  <Button variant="default" onClick={() => onCancel()}>
                    Буцах
                  </Button>
                  <Button variant="outline" color="green" type="submit">
                    Батлах
                  </Button>
                </>
              )}
            </Flex>
          </>
        );
      }}
    </Form>
  );
}
